//SetToCAMA_IBM.tsx ==============================================================
import "../Util/Prototypes";

import * as Default from "../Default";
import * as DrawerMenu from "../Menus/DrawerMenu";
import * as EditValuesIBM from "./EditValuesIBM";
import * as Settings from "../Settings";
import * as Search from "../Search/Search";
import * as SignIn_Auth0 from "../Util/SignIn_Auth0";
import * as SnackBar from "../Util/SnackBar";
import * as Spinner from "../Util/Spinner";
import * as Util from "../Util/Util";
import * as Util_App from "../Util/Util_App";
import * as WidgetHeading from "../Widgets/WidgetHeading";

import { Button, Paper } from "@mui/material";

import Axios, { AxiosResponse } from "axios";

import React from "react";

const toolName: string = "Set to CAMA";

interface iProps {
}

//Render function.
export function Render(props: iProps) {
   //Util.logMsg("Top of Set to CAMA");

   if (DrawerMenu.curToolName === "") {
      return (<div />);
   }

   //Set refresh method.
   const [ignored, refresh] = React.useReducer((x: number) => x + 1, 0);

   //Component did mount.
   React.useEffect(() => {
   }, []);

   //Close this tool.
   function close() {
      DrawerMenu.closeTool();
   }

   //Set values.
   function setValues() {
      if (Search.grandTotRec === 0) {
         return; //Quit if clear button was pressed.
      }

      if (Spinner.busy) {
         return; //Quit if busy.
      }
      Spinner.show();

      let i: number;
      let feature: any;
      const pinList: string[] = [];
      const ii: number = Search.activeLayerIndex;

      //Build list of pins.
      for (i = 0; i < Search.layers[ii].fs.features.length; i++) {
         feature = Search.layers[ii].fs.features[i];
         const fields: Util_App.iField[] = Util_App.getFeatureValues(Search.layers[ii].fs, feature, Settings.parcelLayerName, Settings.pin_fieldName);
         pinList.Add(fields[0].value);
      }

      //Set values on server.
      const ajaxData: Default.iAjaxData = { action: "setToCAMA_IBM", userName: SignIn_Auth0.userName, pinList: pinList };

      const webAPI_path = Util_App.getWebAPI_path();

      Axios.post(webAPI_path, ajaxData)
         .then(function (response) {
            setTimeout(function () { Spinner.hide(); }, 500); //Wait to avoid fumble finger multiple clicks.

            if (!response) {
               Util.errMsg("ajax results from server are null");
               return;
            }
            if (response.data.errMsg !== "") {
               SnackBar.show(response.data.errMsg);
               return;
            }
            SnackBar.show("Successfully set reassessment values to CAMA values", 5);
            EditValuesIBM.refreshMap();
         })
         .catch(function (error) {
            Spinner.hide();
            Util.errMsg("ajax error setting IBM values.", error);
         });
   }

   return (
      <Paper>
         <WidgetHeading.Render title={"Set to CAMA"} onClose={close} />

         <div className="app-flex-row-around" style={{ padding: 7 }}>
            <Button variant="contained" size="medium" color="primary" onClick={setValues} title="Set to CAMA values">
               Apply
            </Button>
         </div>

      </Paper>
   ); //end return.

} //end function.
